const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppointementList/AddToCalendarComponent/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        addToCalendar: 'Meinem Kalender hinzufügen',
        responsiblePerson: 'Verantwortliche Person: {responsiblePerson}',
    },
    __RELATIVE_SOURCE_FILE__
);
